export const SMS_VERIFICATION_SERVER_URL = "https://fqr8t7ueqe.execute-api.eu-central-1.amazonaws.com/test-20190315";
export const SEND_ENDPOINT = "send";
export const VERIFY_ENDPOINT = "verify";

export const MAX_SMS_COUNT = 3;

/**
 * Default language that will be applied for whole web.
 * The value is passed in api request
 * @type {string}
 */
export let LANGUAGE = "de";

/**
 * Fallback language that will be applied if appropriate item is not found in LANGUAGE
 * @type {string}
 */
export const FALLBACK_LANGUAGE = "de";

/**
 * Supported language codes
 * @type {string[]}
 */
export const supportedLanguageCodes = [
    "en",
    "de",
    "ro"
];


/**
 * Design of the pages based on payment system + design (in the future).
 *
 * @type {string}
 */
export let DESIGN = "PBPAY";

export function setDesign(design) {
    DESIGN = design;
}

/**
 * Return url
 * @type {string}
 */
export let RETURN_URL="";

export function setReturnUrl(url){
    RETURN_URL = url;
}

/**
 * Sets global language of the service.
 * If inserted value is not in supported language types, sets it to fallback language instead.
 * @param language
 */
export function setLanguage(language){
    //Might not work on very old browsers
    var normalisedLanguage = language.toLowerCase();
    if(!supportedLanguageCodes.includes(normalisedLanguage)){
        console.log('Unsupported language ' +normalisedLanguage + '. Using fallback language');
        LANGUAGE = FALLBACK_LANGUAGE;
    }else{
        console.log('Setting language to '+normalisedLanguage);
        LANGUAGE = normalisedLanguage;
    }

}


// WEBPACK FOOTER //
// ./src/js/GlobalConfiguration.js